// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lba-dnd-two-lists .lba-wrapper[data-v-36b18c5f]{max-width:none!important}.lba-dnd-two-lists .lba-wrapper .flex-row[data-v-36b18c5f]{padding:4px 10px!important}", ""]);
// Exports
module.exports = exports;
